import { createFileRoute } from '@tanstack/react-router'
import UmbrellaHomeV5 from '@/components/umbrella/UmbrellaHomeV5'

export const Route = createFileRoute('/home-v5')({
  component: UmbrellaHomeV5,
})
